export const API_CREATE_ORG = 'API_CREATE_ORG';
export const API_CREATE_ORG_SUCCESS = 'API_CREATE_ORG_SUCCESS';
export const API_CREATE_ORG_FAILED = 'API_CREATE_ORG_FAILED';

export const RESET_ONBOARDING = 'RESET_ONBOARDING';
